import {useParams, Link} from 'react-router-dom'
import {useState, useEffect } from 'react'

import CommaList from '../CommaList/commalist.component'
import BreadCrumb from '../BreadCrumb/breadcrumb.component'
import Gallery from '../Gallery/gallery.component'
import Loader from '../Loader/loader.component'

import Popup from 'reactjs-popup'

import 'reactjs-popup/dist/index.css';

import './resource.styles.css'

import Emblem from '../Emblem/emblem.component'

import { useTranslation } from "react-i18next";
import "../../translations/i18n";

import Map from '../Map/map.component'

function truncate( str, n, useWordBoundary ){
    if (str.length <= n) { return str; }
    const subString = str.slice(0, n-1); // the original check
    return (useWordBoundary 
      ? subString.slice(0, subString.lastIndexOf(" ")) 
      : subString) + "...";
  };


const Resource = ({apiUrl, lang, filteredResources, searchUrl}) => {

    const {resourceId} = useParams();

    const [resource, setResource] = useState([]);
    const [spinner, setSpinner] = useState(false)
    const [related, setRelated] = useState([]);

    const { t } = useTranslation();

    //console.log(searchUrl);

    useEffect(()=>{
       fetch(apiUrl+'Resources/'+resourceId)
      .then(response=> response.json())
      .then((resource) => {
        setRelated([]);
        setResource(resource);

        setSpinner(true)
        })
    },
    [resourceId,apiUrl]);


    useEffect(()=>{
        if (resource.Resource2Resource?.length > 0) {
            
            resource.Resource2Resource.forEach((resource, index) => {
                const relatedId = resource.Id_Resource2;
                fetch(apiUrl+'Resources/'+relatedId)
                .then(response=> response.json())
                .then((related) => {
                    setRelated(oldrel => [...oldrel, related]);
                })
            });

    }}, [resource])

    const get_prev = () => {
        if (!resource) return;
        if (filteredResources === undefined || filteredResources.length == 0 ) return;
        const index = filteredResources?.findIndex(o => o.Id === resource.Id);
        if (index == 0) return;
        const target_resource = filteredResources[index-1];
        return (
            <Link to={`/resources/${target_resource.Id}`}>&lsaquo; {target_resource.Abbreviation }{target_resource.Abbreviation?':':''} {truncate(target_resource.Name, 25, true)}</Link>
        )

    }

    const get_next = () => {
        if (!resource) return;
        if (filteredResources === undefined || filteredResources.length == 0 ) return;
        const index = filteredResources?.findIndex(o => o.Id === resource.Id);
        if (index + 1 == filteredResources.length) return;
        const target_resource = filteredResources[index+1];
        return (
            <Link to={`/resources/${target_resource.Id}`}>{target_resource.Abbreviation }{target_resource.Abbreviation?':':''} {truncate(target_resource.Name, 25, true)} ›</Link>
        )
    }

    if (spinner) {
        var id_for_emblem = resource.Type.reduce(function(p,c) {
            return p.Id < c.Id ? p : c;
        })
    }

    const tmp_multimedia = 'https://picsum.photos/id/0/1024/768 https://picsum.photos/id/1/1024/768 https://picsum.photos/id/2/1024/768 https://picsum.photos/id/3/1024/768 https://lab.dariah.pl/wp-content/uploads/2022/08/Dariah_pl_PO_KOREKCIE.mp4';

    if (!spinner) return (
        <>
            <Loader></Loader>
        </>
    )


    const contentStyle = { width: '600px', height: '600px' };

    return spinner && (
        <>
        <BreadCrumb paths={
            [
                {
                    Name: t('breadcrumb.start.name'),
                    Url: t('breadcrumb.start.url')
                },
                {
                    Name: t('breadcrumb.infrastructure.name'),
                    Url: t('breadcrumb.infrastructure.url')
                  },
                {
                    Name:t('breadcrumb.catalogue.name'),
                    Url:t('breadcrumb.catalogue.url'),
                },
                {
                    Name:t('breadcrumb.search.name'),
                    Url: searchUrl?searchUrl:t('breadcrumb.search.url')
                },
                {
                    Name: (resource.Abbreviation?resource.Abbreviation+": ":"")+resource.Name,
                    Url:''
                }
            ]
            }
        />
       
        <div className="resource-header">
            <Emblem 
                alt={id_for_emblem.Name} 
                kind={`type`}
                id={id_for_emblem.Id}
                big={false}
                noborder={true}
            />
            <h1>{resource.Abbreviation}{resource.Abbreviation?':':''} {resource.Name}</h1>
        </div>

        <p className="resource-tagline">{resource.Tagline}</p>

        <div className="resource-wrapper">
            <div >
                <div>
                    <p>{resource.Description}</p>
                </div>
                

                <div className="resource-types">
                    <ul>
                        <li><strong>{t('resource.resource_type')}:</strong> 
                            <CommaList nameDescList={resource.Type} info="1" />
                        </li>
                  
                        <li><strong>{t('resource.resource_accesstype')}:</strong> 
                            <CommaList nameDescList={resource.AccessType} join=" /" info="1" / >
                        </li>
                        <li><strong>{t('resource.resource_accessmode')}:</strong>
                            <CommaList nameDescList={resource.AccessMode} join=" /" info="1"/>;
                            <CommaList nameDescList={resource.OrderInfo} join=" /" info="1"/>
                        </li>
                        
                        { resource.AccessMode?.filter((elem)=> elem.Id === 2 || elem.Id===3 ).length > 0  &&
                        <li>
                           <strong>{t('resource.price_list')}: </strong> <a href={`/${t('resource.price_list_url')}/?id=${resourceId}`} target="_blank">{t('resource.price_list_link')}</a>
                        </li>
                        }
                        { resource.Location &&
                        
                        <li><strong>{t('resource.resource_location')}: </strong>
                            <>
                                
                                <Popup
                                    trigger={ open => (
                                        
                                        <span style={{cursor: 'pointer', display: 'inline-flex'}} >
                                            {t('resource.resource_location_country')} {resource.Location.City}, {resource.Location.Street} {resource.Location.Number} 
                                        <img src={require('../../assets/img/resources/marker_empty.png')} style={{width: '20px', height: '20px'}}/>
                                        </span>
                                        
                                        
                                    )}
                                    position="top left"
                                    {... {contentStyle}}
                                    >
                                    <div style={{position: 'relative', height: '100%', width: '100%'}}>
                                        <Map apiUrl={apiUrl} lang={lang} fix={resourceId}/>
                                    </div>
                                </Popup>
                            </>
                        </li>
                        }
                    </ul>
                </div>
            
            

            { resource.Multimedia && false &&
                <div className="multimedia-container">
                        <object data={resource.Multimedia}></object>
                </div>
            }
                <div className="resource-classification">
                <h2>{t('resource.resource_classification')}</h2>
                    <ul>

                        { resource.Laboratory.length >0 &&
                        <li>
                            <strong>{t('resource.laboratory')}:</strong>
                            <CommaList nameDescList={resource.Laboratory}/>
                        </li>
                        }

                        { resource.Activity.length >0 &&
                        <li>
                            <strong>{t('resource.activity')}:</strong>
                            <CommaList nameDescList={resource.Activity}/>
                        </li>
                        }

                        { resource.Keyword.length>0 &&
                        <li>
                        <strong>{t('resource.keyword')}:</strong>
                            <CommaList nameDescList={resource.Keyword}/>
                        </li>
                        }

                        { resource.Standard.length>0 &&
                        <li>
                        <strong>{t('resource.standard')}:</strong>
                            <CommaList nameDescList={resource.Standard}/>
                        </li>
                        }

                        { resource.ScientificDomain.length>0 &&
                        <li>
                        <strong>{t('resource.domain')}:</strong>
                            <CommaList nameDescList={resource.ScientificDomain}/>
                        </li>
                        }

                        { resource.TargetUser.length>0 &&
                        <li>
                        <strong>{t('resource.targetuser')}:</strong>
                            <CommaList nameDescList={resource.TargetUser}/>
                        </li>
                        }
                        
                        { resource.Language1.length>0 &&
                        <li>
                        <strong>{t('resource.language')}:</strong>
                            <CommaList nameDescList={resource.Language1}/>
                        </li>
                        }
                    </ul>
                </div>
                {related.length>0 && <div className="resource-related">
                    <h2>{t('resource.related')} ({related.length})</h2>
                    <ul>
                        {
                            related.map((rel, index) => {
                                return (
                                <li key={index}>
                                    <div className="resource-header">
                                        <Emblem 
                                            alt={rel.Type.reduce(function(p,c) {
                                                return p.Id < c.Id ? p : c;
                                            }).Name} 
                                            kind={`type`}
                                            id={rel.Type.reduce(function(p,c) {
                                                return p.Id < c.Id ? p : c;
                                            }).Id}
                                            big={false}
                                            noborder={true}
                                        />
                                        <h3><Link to={`/resources/${rel.Id}`}>{rel.Abbreviation }{rel.Abbreviation?':':''} {rel.Name}</Link></h3>
                                    </div>
                                    <p>{truncate(rel.Description,250,true)}</p>
                                </li>
                                )
                            }
                            )
                        }

                        
                    </ul>
                </div>
            }

        <div className="resource-nav">
            <span>{get_prev()}</span>
            <span>{get_next()}</span>
        </div>

            </div>
            <div className="resource-sidebar">
                <div className="resource-acccess-info">
                    <h2>{t('resource.access_data')}</h2>
                    <ul>
                        <li title={resource.Institution?.Name} style={{cursor:'pointer'}}>
                            <strong>{t('resource.supplier')}:</strong> <a href={resource.Institution?.Webpage} target="_blank">{resource.Institution?.Abbreviation}</a>
                        </li>
                        <li>
                            <strong>{t('resource.webpage')}:</strong> <a target="_blank" href={resource?.Webpage}>{resource?.Webpage}</a>
                        </li>
                        <li>
                            <strong>{t('resource.contact')}:</strong> <a href={`mailto: ${resource?.Email}`}>{resource?.Email}</a>
                        </li>
                    </ul>
                </div>

                <div>
                    { resource.Multimedia && <Gallery multimedia={resource.Multimedia} />}
                    { !resource.Multimedia && <Gallery multimedia={tmp_multimedia}  /> && false}
                </div>
            </div>
        </div>

        </>
    )

    /*
    Ikona ktorej nie mamy, ale jest powiazana z typem zasobu (wstawic generyczna)
    
    Abbrevation:Name
    ----
    Tagline

     Typ zasobu:type
     Słowa kliczowe:keywords i activities
     Tryb dostępu: Polaczony access mode, access type, order info (description jako tooltip)
     Jezyki: language1

     O zasobie: description

    Pod zasoboem jeśli są multimedia to je wstawic (moze to byc image albo video)

    Klasyfikacja:
    laboratorium
    standardy
    docelowe grupy uzytkownikow

    ew. description do niektowych rzeczy tooltipy

    Zasoby powiązane: 
    nie mamy jeszcze - bedziemy pokazywa abbr i name i bedzie to url do innego zasobu

    Przykładowe scenariusze
    (workflowy jestesmyu w lesie)

    Cennik
    (równiez las)

    Dane dostępowae
        Dostawca: institution - dajemy Abbrevation i url dostawcy - webpage
        Website: webpage
        Kontakt: Email


    */
}


export default Resource
